var React = require('react');

var GamePackageLinks = React.createClass({
    linksToShow :{
        soccer : {
            'Report' : 1,
            'Statistics' : 1,
            'Match' : 1
        },
        rugby : {
            'Match' : 1,
            'Report' : 1
        }
    }, 
    render: function(){
        var league = this.props.league;
        var sport = this.props.sport;
        var linksToShow = this.linksToShow[sport];
        var links = this.props.links || [];
        var linksMarkup = [];
        
        links.map(function(link, i){
            var rels = link.rel.join(' ');
            
            // if(linksToShow[link.text]){
                linksMarkup.push(
                    <a data-route="false" key={link.text + '.' + i} name={"&lpos=" + sport + ":scoreboard:" + link.text.toLowerCase()} className="button-alt sm" href={link.href} rel={league + " " + rels}>
                        {link.text}
                    </a>
                );
            // }
        });
        
        return (
            <section className="sb-actions" style={{paddingBottom: '10px'}}>
                {linksMarkup}
            </section>
        );
    }
});

module.exports = GamePackageLinks;


/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/scoreboard/game-strip/GamePackageLinks.jsx
 **/